<template>
  <div class="content-tab poe-consumption">
    <div class="content-body">
      <!-- <div class="content-body-header">{{$t("poe.consumption.currentTitle", ['total'])}}</div> -->
      <div class="content-item-h100">
        <div style="display:flex;">
          <div class="title" style="line-height:30px;">{{$t("poe.choosePort")}}</div>
          <q-select class="q-select" :value="seltype" :options-array="menuOptions" @change="onMenuChange"></q-select>
        </div>
        <div class="consumption-text">
          <div class="current-subtext title">{{currentText}} <span>{{currentPower}}{{$t('poe.simpleWatt')}}</span></div>
          <div class="maxmin-subtext title">{{$t('poe.maxminPower')}} <span>{{minPower}}{{$t('poe.simpleWatt')}} / {{maxPower}}{{$t('poe.simpleWatt')}}</span></div>
        </div>
        <ve-line ref="chart" v-if="isTotal" :data="chartData" :colors="chartConfig.totalColors" :settings="chartConfig.setting" :y-axis="chartConfig.yAxis" :extend="chartConfig.extend" :grid="chartConfig.grid" height="320px" :width="chartWidth"></ve-line>
        <ve-line ref="chart" v-else :data="chartData" :colors="chartConfig.portColors" :settings="chartConfig.setting" :y-axis="chartConfig.yAxis" :extend="chartConfig.extend" :grid="chartConfig.grid" height="320px" :width="chartWidth"></ve-line>
      </div>
    </div>
  </div>
</template>

<script>
import moment from 'moment'
import VeLine from 'v-charts/lib/line.common'
import qSelect from './module/Select.vue'
import {
  mapState,
  // mapMutations,
  mapActions
} from 'vuex'
export default {
  name: 'PoeConsumption',
  components: {
    VeLine,
    qSelect
  },
  data () {
    return {
      totalInterval: null,
      perPortInterval: null,
      perStartTime: null,
      watt: 0,
      portLists: [],
      chartWidth: '100%',
      chartConfig: {
        totalColors: ['#7ED321'],
        portColors: ['#F5A623'],
        setting: {
          labelMap: {
            watt: 'Total Power Consumption /W'
          }
        },
        grid: {
          show: true,
          borderColor: 'none',
          right: 90
        },
        extend: {
          series: {
            symbol: 'none'
          },
          xAxis: {
            name: this.$t('systemMgmt.log.time'),
            nameLocation: 'end',
            nameGap: 10,
            boundaryGap: false,
            axisLine: {
              lineStyle: {
                type: 'dotted'
              }
            },
            axisLabel: {
              show: true,
              interval: function (index, value) {
                if (index === 0 || index === 59) {
                  return true
                } else {
                  return false
                }
              },
              formatter: this.yLabelFormatter
            },
            nameTextStyle: {
              color: '#8C99FF',
              fontSize: 13,
              lineHeight: 22
            }
          },
          legend: {
            show: false
          },
          markLine: {
            data: [{yAxis: 0, x: 'max'}],
            lineStyle: {
              normal: {
                type: 'dashed',
                color: 'red'
              }
            },
            symbol: 'none'
          },
          tooltip: {
            formatter: this.tooltipFormatter
          }
        },
        yAxis: {
          name: this.$t('poe.simpleWatt'),
          splitLine: {
            lineStyle: {
              type: 'dashed',
              color: '#8EA0F9',
              opacity: 0.5
            }
          },
          nameTextStyle: {
            color: '#8C99FF',
            fontSize: 13,
            lineHeight: 22
          }
        }
      },
      chartData: {
        columns: ['time', 'perPortConsumption'],
        rows: []
      },
      seltype: 'total',
      currentPower: 0,
      maxPower: 0,
      minPower: 0,
      isTotal: true,
      testIndex: 0,
      menuOptions: [
        { value: 'total', label: 'poe.total', isDisabled: false }
      ],
      poeList: []
    }
  },
  beforeDestroy () {
    clearInterval(this.totalInterval)
    clearInterval(this.perPortInterval)
    this.menuOptions = [{ value: 'total', label: 'poe.total' }]
  },
  mounted: async function () {
    this.onChangePort()
  },
  created: async function () {
    this.getPoeStatus()
      .then(res => {
        let me = this
        if (res.status === 200) {
          let total = 0
          this.poeList = res.data.result
          res.data.result.forEach(element => {
            total += element.val.PowerConsumption
            me.setDisabled(parseInt(element.key) - 1)
          })
          this.watt = total
          this.setMenuOption()
        }
      })
  },
  watch: {
    lang: {
      handler (value) {
        setTimeout(() => {
          if (this.$refs.chart) {
            this.$refs.chart.$options.propsData.extend.xAxis.name = this.$t('menu.systime')
            this.$refs.chart.$options.propsData.yAxis.name = this.$t('poe.simpleWatt')
          }
          this.setMenuOption()
          this.$forceUpdate()
        }, 200)
      },
      immediate: true
    },
    showQuickHelp: {
      handler (value) {
        let event
        this.chartWidth = (value) ? 'calc(100% - 150px)' : '100%'
        if (typeof (Event) === 'function') {
          event = new Event('resize')
        } else {
          event = document.createEvent('Event')
          event.initEvent('resize', true, true)
        }
        setTimeout(() => {
          if (!value) window.dispatchEvent(event)
          this.chartWidth = (value) ? 'calc(100% - 150px)' : '100%'
        }, 400)
      }
    }
  },
  methods: {
    tooltipFormatter: function (params) {
      return this.$t('poe.tooltips', params[0].data[1])
    },
    yLabelFormatter: function (value, index) {
      if (index === 0) {
        return ' ' + this.$t('minAgo')
      } else if (index === 59) {
        return this.$t('now')
      }
    },
    getMinMaxPower: function (current) {
      if (this.maxPower === 0 || current > this.maxPower) {
        this.maxPower = current
      }
      if (this.minPower === 0 || current < this.minPower) {
        this.minPower = current
      }
    },
    setRateInitailData: function () {
      this.testIndex = 0
      this.chartData.rows = []
      for (var index = 0; index < 60; index++) {
        setTimeout(() => {
          this.chartData.rows.push({
            'time': (this.testIndex++).toString(), 'perPortConsumption': 0
          })
        }, 300)
      }
    },
    onMenuChange: function (value) {
      this.seltype = value
      this.onChangePort()
    },
    onChangePort: function () {
      clearInterval(this.totalInterval)
      clearInterval(this.perPortInterval)
      this.setRateInitailData()
      this.startTime = new Date().getTime()
      this.currentPower = 0
      this.maxPower = 0
      this.minPower = 0
      if (this.seltype === 'total') {
        this.isTotal = true
        this.totalInterval = setInterval(() => {
          try {
            this.getPoeStatus()
              .then(res => {
                if (res.status === 200) {
                  let data = (res.data)
                  let detail = data.result
                  let total = 0
                  detail.forEach(element => {
                    total += element.val.PowerConsumption
                    // me.setDisabled(parseInt(element.key) - 1)
                  })
                  detail.perPortConsumption = total / 10
                  this.currentPower = total / 10
                  this.getMinMaxPower(this.currentPower)
                  detail.time = (this.testIndex++).toString()
                  this.chartData.rows.shift()
                  this.chartData.rows.push(detail)
                }
              })
              .catch(error => {
                this.$log.error(error)
                if (this.totalInterval) {
                  clearInterval(this.totalInterval)
                }
              })
          } catch (err) {
            this.$log.error(err)
          }
        }, 3000)
      } else {
        this.isTotal = false
        this.perPortInterval = setInterval(() => {
          try {
            this.getPoeStatus()
              .then(res => {
                if (res.status === 200) {
                  let data = (res.data)
                  let detail = data.result
                  detail.forEach(element => {
                    if (element.key === this.seltype) {
                      element.perPortConsumption = element.val.PowerConsumption / 10
                      this.currentPower = element.val.PowerConsumption / 10
                      this.getMinMaxPower(this.currentPower)
                      this.watt = parseInt(element.val.PowerReserved / 10)
                      element.time = (this.testIndex++).toString()
                      this.chartData.rows.shift()
                      this.chartData.rows.push(element)
                    }
                  })
                  // for (const key in detail) {
                  //   if (detail.hasOwnProperty(key)) {
                  //     let element = detail[key]
                  //     let port = this.$getPortName(element.key)
                  //     if (port === Number(this.seltype)) {
                  //       element.perPortConsumption = element.val.PowerConsumption / 10
                  //       this.currentPower = element.val.PowerConsumption / 10
                  //       this.getMinMaxPower(this.currentPower)
                  //       this.watt = parseInt(element.val.PowerReserved / 10)
                  //       element.time = (this.testIndex++).toString()
                  //       this.chartData.rows.shift()
                  //       this.chartData.rows.push(element)
                  //     }
                  //   }
                  // }
                  this.$log.debug(this.chartData)
                }
              })
              .catch(error => {
                this.$log.error(error)
                if (this.perPortInterval) {
                  clearInterval(this.perPortInterval)
                }
              })
          } catch (err) {
            this.$log.error(err)
          }
        }, 3000)
      }
    },
    setDisabled: function (key) {
      if (this.poeList[key - 1] && this.poeList[key - 1].val.SupportMode === 'noSupport') {
        return true
      }
      return false
    },
    getTips: function (key) {
      let tips = ''
      if (this.setDisabled(key)) {
        tips = this.$t('poe.notSup')
      }
      return tips
    },
    setMenuOption: function () {
      this.menuOptions = [{ value: 'total', label: 'poe.total', isDisabled: false }]
      for (let port = 1; port <= this.portNumber; port++) {
        let disabled = this.setDisabled(port)
        let title = this.getTips(port)
        this.menuOptions.push({
          value: '' + port,
          label: this.$t('poe.port', port),
          isDisabled: disabled,
          title: title
        })
      }
      this.$log.debug(this.menuOptions)
    },
    ...mapActions([
      'getPoeStatus'
    ])
  },
  computed: {
    ...mapState({
      lang: state => state.app.lang,
      portNumber: state => state.module.portNum,
      showQuickHelp: state => state.app.showQuickHelp
    }),
    displayDateTime: function () {
      let displayTime = ''
      if (this.systemTime) {
        displayTime = moment(this.systemTime.SystemCurTime).format(this.systemTime.SystemCurTimeFormat)
      } else {
        displayTime = 'unknow'
      }
      return displayTime
    },
    currentText: function () {
      let result = ''
      if (this.seltype === 'total') {
        result = this.$t('poe.totalPower')
      } else {
        result = this.$t('poe.currentTitle', [this.seltype])
      }
      return result
    }
  }
}
</script>
<style lang="scss" scoped>
// @import '../assets/scss/variables.scss';

.content-tab.poe-consumption {
  .content-body {
    padding-top: 20px;
    padding-left: 20px;
    >.content-item-h100 {
      >div {
        padding: 0px 30px;
      }
      select.port {
        margin-left: 7px;
      }
      >.consumption-text {
        margin-top: 10px;
        display: flex;
        >.maxmin-subtext {
          margin-left: 20px;
        }
        span {
          color: #6370AF;
        }
      }
    }
  }
  .port {
    width: 200px !important;
  }
  .current-total, .choose-port {
    float: left;
    margin-right: 20px;
  }
  .q-select .display-label {
    font-size: 13px;
    color: #000;
  }
  .q-select {
    width: auto;
    height: 30px;
    border: 1px solid #979797 !important;
    border-radius: 4px;
    margin-left: 10px;
    // margin-top: 4px;
    /deep/ .dropdown-menu {
      left: -1px;
      width: auto;
      height: auto;
      // overflow: auto;
    }
    /deep/ .display-label {
      font-size: 13px !important;
      color: #2F2F2F !important;
      line-height: 30px !important;
    }
    &::after {
      background-color: #000;
      top: -25px;
    }
  }
}

</style>



// WEBPACK FOOTER //
// src/components/PoeConsumption.vue